import { SiteType } from "../../types/api";
import { createDocsUrl } from "../../utils/urls";

export const isSetupCompleted = (site: SiteType) => {
  return (
    site.title &&
    site.description &&
    site.favicon &&
    site.headline &&
    site.subtext &&
    site.featured_image &&
    site.logo &&
    site.active_subscription
  );
};

export const getSetupSteps = (site: SiteType) => {
  const items = [
    {
      title: "Site Content",
      description:
        "Update your site content including, headlines links and images",
      link: `/${site.id}/edit`,
      completed:
        site.headline && site.subtext && site.logo && site.featured_image,
    },
    {
      title: "View your site",
      description: "Preview your site and see how it looks",
      link: `https://${createDocsUrl(site)}`,
      completed: false,
    },
    {
      title: "Choose a plan",
      description: "Choose a pricing plan that best fits your business",
      link: `/${site.id}/choose-plan`,
      completed: site.active_subscription !== "none",
    },

    {
      title: "Custom domain",
      description: "Setup a custom domain for your site",
      link: `/${site.id}/settings/urls`,
      completed: !!site.custom_domain,
    },
  ];

  return items;
};
